/**
 * Configuration de marque (white-label) côté frontend.
 *
 * La marque active est déterminée au build par REACT_APP_BRAND (défaut : "asar").
 * Le défaut "asar" reproduit l'identité existante (iso-design).
 *
 * Les couleurs servent de référence ; l'application visuelle passe par les
 * variables CSS de thème (voir src/styles/theme.css) sélectionnées via
 * l'attribut data-brand sur <html>.
 */

const BRANDS = {
  asar: {
    key: 'asar',
    name: 'ASAR CSG',
    legalName: 'ASAR CONSEILS SOLUTIONS GESTION',
    orias: '19003553',
    legalForm: 'Société par actions simplifiée',
    capital: '3 000 €',
    address: '92 Rue de la Bonne Aventure, 78000 Versailles',
    rcs: 'Versailles 840 327 290',
    siret: '840 327 290',
    president: 'M. Sokha Tan',
    tagline: 'Courtier en Assurances',
    contactEmail: 'gestion@asarcsg.com',
    comptaEmail: 'mail@asar-csg.com',
    phone: '01 84 80 87 29',
    websiteUrl: 'https://asarcsg.com',
    defaultLocale: 'fr',
    locales: ['fr', 'en'],
    logo: 'https://customer-assets.emergentagent.com/job_permission-panel/artifacts/n820ks44_ASAR_Final_Transparent%20reduit%20%283%29.png',
    meta: {
      windowTitle: 'ASAR CSG - Courtier en Assurances',
      shortName: 'ASAR',
      description: 'ASAR CSG - Votre courtier en assurances. Espace client, devis et gestion de contrats.',
      favicon: '/icons/icon-32x32.png',
      appleIcon: '/icons/icon-192x192.png',
    },
    colors: {
      primary: '#34B0D8',
      primaryHover: '#2A9BC1',
      accent: '#34B0D8',
      heading: '#1F2937',
      text: '#4A4A4A',
      background: '#FFFFFF',
    },
  },
  dna: {
    key: 'dna',
    name: 'DNA-24',
    legalName: 'DISRUPTIVE NETCARE ASSISTANCE 24',
    orias: '15005576',
    legalForm: 'Société par actions simplifiée',
    capital: '50 000 €',
    address: '92 Rue de la Bonne Aventure, 78000 Versailles',
    rcs: '813 619 319 R.C.S. Versailles',
    siret: '813 619 319 00037',
    president: 'Tan Sokha',
    tagline: 'Worldwide Reach with Human Touch',
    contactEmail: 'hello@dna-24.com',
    comptaEmail: 'hello@dna-24.com',
    phone: '', // Aucun numéro pour l'instant
    websiteUrl: 'https://dna-24.com',
    defaultLocale: 'en',
    locales: ['en', 'fr'],
    logo: '/dna/dna24-logo.png',
    meta: {
      windowTitle: 'DNA-24 - Worldwide Reach with Human Touch',
      shortName: 'DNA-24',
      description: 'DNA-24 - Worldwide healthcare assistance. Client space, quotes and contract management.',
      favicon: '/dna/dna24-logo.png',
      appleIcon: '/dna/dna24-logo.png',
    },
    // Identité visuelle DNA-24 (référence ; rendu via theme.css) — direction claire & chaleureuse
    colors: {
      primary: '#1E4D38',
      primaryHover: '#16382A',
      accent: '#E2906F',
      accentHover: '#D67E5F',
      heading: '#243029',
      text: '#4A4A42',
      textLight: '#6E6E64',
      mint: '#EAE0CE',
      aqua: '#E2906F',
      ivory: '#FBF7F0',
      background: '#FBF7F0',
      gradient: 'linear-gradient(135deg, #1E4D38 0%, #2D634A 100%)',
    },
  },
};

export const BRAND_KEY = (() => {
  // Override temporaire de preview (bouton BrandSwitcher) — DEV uniquement, jamais en prod.
  const override = (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.localStorage)
    ? window.localStorage.getItem('previewBrand')
    : null;
  return (override || process.env.REACT_APP_BRAND || 'asar').toLowerCase();
})();

export const brand = BRANDS[BRAND_KEY] || BRANDS.asar;

export default brand;
